import { call, put, takeLatest } from "redux-saga/effects";
import { getActiveStudySuccess, getDetailStudySuccess, getHeartBeatSuccess, getPerFacilitySuccess, getSecuredHeartBeatSuccess, getUtilizationChartRatesSuccess, getUtilizationRatesStudySuccess, GET_ACTIVE_STUDY_FAILURE, GET_ACTIVE_STUDY_REQUEST, GET_DETAIL_STUDY_FAILURE, GET_DETAIL_STUDY_REQUEST, GET_HEART_BEAT_STUDY_FAILURE, GET_HEART_BEAT_STUDY_REQUEST, GET_PER_FACILITY_FAILURE, GET_PER_FACILITY_REQUEST, GET_SECURED_HEART_BEAT_STUDY_REQUEST, GET_UTLIZATION_CHART_RATES_REQUEST, GET_UTLIZATION_RATES_PROCEDURE_CHART_REQUEST, GET_UTLIZATION_RATES_PROCEDURE_REQUEST, GET_UTLIZATION_RATES_STUDY_REQUEST, GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_REQUEST } from "../actions/patientAction";
import { getActiveStudyAPICall, getDetailStudyAPICall, getHeartBeatAPICall, getPerFacilityStudyAPICall, getSecuredHeartBeatAPICall, getUtilizationRatesBeatAPICall, getUtilizationRatesChartBeatAPICall, getUtilizationRatesProcedureAPICall, getUtilizationRatesProcedureChartAPICall, getUtilizationSecuredHeartBeatAPICall } from "../apis/studyCallApi";
import { checkAuthorizationError } from "../utils/notification-helpers";



function * getActiveStudyHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getActiveStudyAPICall,payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getActiveStudySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_ACTIVE_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getDetailStudyHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getDetailStudyAPICall,payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getDetailStudySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_DETAIL_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getPerFacilityHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getPerFacilityStudyAPICall,payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getPerFacilitySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_PER_FACILITY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getHeartBeatHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getHeartBeatAPICall,payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getHeartBeatSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getSecuredHeartBeatHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getSecuredHeartBeatAPICall)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getSecuredHeartBeatSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getUtilizationSecuredHeartBeatHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getUtilizationSecuredHeartBeatAPICall)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getSecuredHeartBeatSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getUtilizationRatesChartHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getUtilizationRatesChartBeatAPICall)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getUtilizationChartRatesSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getUtilizationRatesStudyHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getUtilizationRatesBeatAPICall)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getUtilizationRatesStudySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getUtilizationRatesProcedureHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getUtilizationRatesProcedureAPICall)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getUtilizationRatesStudySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * getUtilizationRatesProcedureChartHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(getUtilizationRatesProcedureChartAPICall)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getUtilizationRatesStudySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_HEART_BEAT_STUDY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

export function * studySaga () {
  yield takeLatest(GET_UTLIZATION_SECURED_HEART_BEAT_STUDY_REQUEST, getUtilizationSecuredHeartBeatHandler)
  yield takeLatest(GET_UTLIZATION_RATES_PROCEDURE_CHART_REQUEST, getUtilizationRatesProcedureChartHandler)
  yield takeLatest(GET_UTLIZATION_RATES_PROCEDURE_REQUEST, getUtilizationRatesProcedureHandler)
  yield takeLatest(GET_UTLIZATION_CHART_RATES_REQUEST, getUtilizationRatesChartHandler)
  yield takeLatest(GET_UTLIZATION_RATES_STUDY_REQUEST, getUtilizationRatesStudyHandler)
  yield takeLatest(GET_SECURED_HEART_BEAT_STUDY_REQUEST, getSecuredHeartBeatHandler)
  yield takeLatest(GET_HEART_BEAT_STUDY_REQUEST, getHeartBeatHandler)
  yield takeLatest(GET_ACTIVE_STUDY_REQUEST, getActiveStudyHandler)
  yield takeLatest(GET_DETAIL_STUDY_REQUEST, getDetailStudyHandler)
  yield takeLatest(GET_PER_FACILITY_REQUEST, getPerFacilityHandler)
}